import { http } from '@/app/lib/http/client'

export interface ProductType {
    id: number
    name: string
    code: string
    requires_lot: number
    description?: string
    created_at?: string
    updated_at?: string
}

export interface CreateProductTypePayload {
    name: string
    code: string
    requires_lot: number
    description?: string
    parent_id?: number | null
}

export interface UpdateProductTypePayload {
    name?: string
    code?: string
    requires_lot?: number
    description?: string
    parent_id?: number | null
}

export const productTypeService = {
    async getProductTypes(params?: { per_page?: number; search?: string }) {
        const response = await http.get('/product-types', { params })
        return response.data
    },

    async getProductType(id: number) {
        const response = await http.get(`/product-types/${id}`)
        return response.data
    },

    async createProductType(payload: CreateProductTypePayload) {
        const response = await http.post('/product-types', payload)
        return response.data
    },

    async updateProductType(id: number, payload: UpdateProductTypePayload) {
        const response = await http.put(`/product-types/${id}`, payload)
        return response.data
    },

    async deleteProductType(id: number) {
        const response = await http.delete(`/product-types/${id}`)
        return response.data
    },
}
